import { FC } from 'react';
import BPIcon, { icons } from './BPIcon';
import { cn } from 'lib/utils';

interface BPIconButtonProps {
  icon: keyof typeof icons;
  onClick?: () => void;
  disabled?: boolean;
  iconClassName?: string;
  small?: boolean;
}

const BPIconButton: FC<BPIconButtonProps> = ({
  icon,
  iconClassName = '',
  onClick = () => {},
  disabled = false,
  small = false,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'group/button grid relative place-content-center bg-black/20 rounded-full hover:bg-white active:bg-white/70 pointer-events-auto disabled:pointer-events-none backdrop-blur-sm',
        small ? 'w-[32px] h-[32px]' : 'w-[56px] h-[56px]'
      )}
    >
      <div
        className={cn(
          'block absolute top-0 left-0 w-full h-full bg-gradient-to-b from-white/30 to-white/10 group-hover/button:bg-white',
          border1px
        )}
      />
      <BPIcon
        icon={icon}
        className={cn(
          'fill-white group-hover/button:fill-gray-800 group-disabled/button:fill-gray-800',
          iconClassName
        )}
      />
    </button>
  );
};

const border1px =
  '[clip-path:polygon(50.142%_97.375%,50.142%_97.375%,57.825%_96.755%,65.114%_94.96%,71.91%_92.088%,78.117%_88.236%,83.636%_83.501%,88.371%_77.982%,92.223%_71.775%,95.095%_64.979%,96.89%_57.69%,97.51%_50.006%,97.51%_50.006%,96.89%_42.323%,95.095%_35.034%,92.223%_28.238%,88.371%_22.031%,83.636%_16.512%,78.117%_11.777%,71.91%_7.925%,65.114%_5.053%,57.825%_3.258%,50.142%_2.638%,50.142%_2.638%,42.458%_3.258%,35.169%_5.053%,28.373%_7.925%,22.166%_11.777%,16.647%_16.512%,11.912%_22.031%,8.06%_28.238%,5.188%_35.034%,3.393%_42.323%,2.773%_50.006%,2.773%_50.006%,3.393%_57.69%,5.188%_64.979%,8.06%_71.775%,11.912%_77.982%,16.647%_83.501%,22.166%_88.236%,28.373%_92.088%,35.169%_94.96%,42.458%_96.755%,50.142%_97.375%,50.142%_99.129%,42.174%_98.486%,34.615%_96.625%,27.567%_93.646%,21.13%_89.651%,15.406%_84.742%,10.497%_79.018%,6.502%_72.581%,3.523%_65.533%,1.662%_57.974%,1.019%_50.006%,1.019%_50.006%,1.662%_42.039%,3.523%_34.48%,6.502%_27.432%,10.497%_20.995%,15.406%_15.271%,21.13%_10.361%,27.567%_6.367%,34.615%_3.388%,42.174%_1.527%,50.142%_0.884%,50.142%_0.884%,58.11%_1.527%,65.668%_3.388%,72.716%_6.367%,79.153%_10.361%,84.877%_15.271%,89.787%_20.995%,93.781%_27.432%,96.76%_34.48%,98.621%_42.039%,99.264%_50.006%,99.264%_50.006%,98.621%_57.974%,96.76%_65.533%,93.781%_72.581%,89.787%_79.018%,84.877%_84.742%,79.153%_89.651%,72.716%_93.646%,65.668%_96.625%,58.11%_98.486%,50.142%_99.129%,50.142%_99.129%)]';

export default BPIconButton;
